import { getParam } from '../utils'

export const _DESKTOP_ = 1
export const _MOVIL_ = 2
export const movilMaxWidth = 768
export const ACTION = {
  click: 1,
  print: 2
}
export const AD_TYPE = {
  Basic: 1,
  PopUp: 2,
  Fixed: 3,
  Multiple: 4
}

export const STATUS_ERROR = -1
export const URL_BASE = import.meta.env.VITE_URL_BASE

export const AdParam = getParam()
